<template ref="appFooter">
  <footer class="AppFooter-root">
    <section class="ft-pc">
      <div class="ft-pc-c g-box">
        <div class="flex-sb" v-show="animateShow">
          <div class="lt">
            <img class="logo_white animate__animated animate__lightSpeedInLeft" src="../../assets/logo_fff.png" alt="">
            <p class="slogan animate__animated animate__lightSpeedInLeft animate__slow">APP、小程序、系统等软件定制开发企业服务商，为您提供专业的解决方案。</p>
          </div>
          <div class="ct">
            <ul class="contact-ul animate__fadeInUp animate__animated">
              <li class="contact-li">
                <h3 class="h3">咨询热线</h3>
                <p class="number" @click="copyInfo(moduleData.site_admin_phone)" title="点击复制电话号码">{{ moduleData.site_admin_phone }}</p>
              </li>
            </ul>
            <div class="connection animate__fadeInUp animate__animated animate__slow">
              <h3 class="h3">联系我们</h3>
              <p class="text" title="点击复制邮箱" @click="copyInfo(moduleData.site_admin_email)">邮箱：{{ moduleData.site_admin_email }}</p>
              <p class="text" title="点击复制公司地址" @click="copyInfo((moduleData._site_admin_address||[])[0] + (moduleData._site_admin_address||[])[1])">公司地址：{{ (moduleData._site_admin_address || [])[0] + (moduleData._site_admin_address||[])[1] }}</p>
            </div>
          </div>
          <div class="rt">
            <h3 class="h3 animate__animated animate__lightSpeedInRight">关注公众号</h3>
            <img class="img animate__animated animate__lightSpeedInRight animate__delay-1s" :src="moduleData.site_admin_img1" alt="">
            <p class="text animate__lightSpeedInRight animate__slower">软件开发从这里开始</p>
          </div>
        </div>
        <!--<div v-show="animateShow" class="flex-sb">
          <div class="lt" ref="left">
            <div class="h5 animate__animated animate__lightSpeedInLeft">{{ moduleData.site_admin_corporate }}</div>
            <p class="animate__animated animate__lightSpeedInLeft animate__slow">地址：{{ moduleData._site_admin_address?moduleData._site_admin_address[0]:'' }}</p>
            <p class="animate__animated animate__lightSpeedInLeft animate__slow" style="text-indent: 3em">{{ moduleData._site_admin_address ? moduleData._site_admin_address[1]:'' }}</p>
            <p class="f-btn-base animate__animated animate__lightSpeedInLeft animate__delay-1s" title="点击复制电话号码" @click="copyInfo('020-37887010')">电话：{{ moduleData.site_admin_phone }}</p>
            <p class="f-btn-base animate__animated animate__lightSpeedInLeft animate__slower" title="点击复制邮箱" @click="copyInfo('1033923823@qq.com')">邮箱：{{ moduleData.site_admin_email }}</p>
          </div>
          <div class="rt" ref="right">
            <div class="h6 animate__animated animate__lightSpeedInRight">免费咨询热线</div>
            <div class="h4 f-btn-base animate__animated animate__lightSpeedInRight animate__slow" title="点击复制咨询热线" @click="copyInfo('020-37887010')">{{ moduleData.site_admin_phone }}</div>
            <div class="imgBox animate__animated animate__lightSpeedInRight animate__delay-1s">
              <img class="img" :src="moduleData.site_admin_img1" alt="" @click="openImg($event)">
              <img class="img" :src="moduleData.site_admin_img2" alt="" @click="openImg($event)">
            </div>
            <p class="animate__animated animate__lightSpeedInRight animate__slower">微信公众号</p>
          </div>
        </div>-->
        <div v-show="animateShow">
          <p class="p animate__animated animate__fadeInUp animate__slow">{{ moduleData.site_gwa }}</p>
		  <a style="display: block;color:#999" class="p animate__animated animate__fadeInUp animate__delay-1s" target="_blank" href="https://beian.miit.gov.cn">{{ moduleData.site_icp }}</a>
        </div>
      </div>
    </section>
    <!--返回到顶部-->
    <BackTop :bottom="backTopS.bottom">
      <div class="m-backTop">
        <div class="inner">
          <p>回到</p>
          <p>顶部</p>
        </div>
        <p class="outer">
          <em class="iconfont iconrocket"></em>
        </p>
      </div>
    </BackTop>
    <!--图片对话框-->
    <Modal
        v-model="imgModel.show"
        class-name="vertical-center-modal"
        :footer-hide="true"
    >
      <div class="m-imgBodel"><img class="img" :src="imgModel.img" alt=""></div>
    </Modal>
  </footer>
</template>
<script>
  import utils from '@/utils';
  export default {
    name       : 'AppFooter',
    components : {},
    props      : {
      animateShow : {
        type : Boolean,
        default : true
      },
      moduleData:{
        type : Object,
        default(){return {};},
      },
    },
    data(){
      return {
        nav      : [
          {id : 0, icon : 'iconshouye', title : '首页', url : 'html'},
          {id : 1, icon : 'iconweibiaoti35', title : '定制开发', url : 'products.html'},
          {id : 2, icon : 'iconshouhoufuwu-chapingfangyu', title : '自营系统', url : 'products.html'},
          {id : 3, icon : 'iconxinwengonggao', title : '成功案例', url : 'products.html'},
          {id : 4, icon : 'iconxinwengonggao', title : '关于澄信', url : 'products.html'},
        ],
        backTopS : {
          height : 100, //页面滚动高度达到该值时才显示BackTop组件
          bottom : 90, //组件距离底部的距离
        },
        imgModel:{
          show:false,
          img:''
        },
      };
    },
    computed   : {},
    created(){
    },
    methods    : {
      orientationPage(){ // 定位nav的current
        this.nav.map((item, index) => {
          if (location.href.indexOf(item.url) > -1) {
            this.current = index;
          }
        });
      },
      changeCurrent(item){// 切换页面
        this.current = item.id;
        // location.href = item.url;
      },
      copyInfo(str){
        this.$utils.copyStr(str).then((res)=>{
          this.$Message.success({content : '复制成功'});
        });
      },
      openImg(e){
        var src = e.currentTarget.getAttribute('src');
        // console.log(src);
        this.imgModel = {
          show:true,
          img:src
        }
      },
    },
  };
</script>
<style scoped lang="scss">
  .AppFooter-root{
    .ft-pc{
      background: #202020;
      padding: 40Px 0 36Px;
      .ft-pc-c{
        color: #999;
        font-size: 14px;
        .lt{
          width: 280px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .logo_white{
          width: 280px;
        }
        .slogan{
          width: 100%;
          background: #333;
          display: flex;
          padding: 14px 20px;
          line-height: 1.6;
          border-radius: 8px;
          color:#fff;
        }
        .rt{
          .img{
            width: 200px;
            height: 200px;
          }
          .text{
            margin-top: 20px;
            text-align: center;
            font-size: 16px;
          }
        }
        .p{
          text-align: center;
        }
        .h3{
          color: #fff;
          font-size: 20px;
          line-height: 1;
          margin-bottom: 16px;
        }
      }
      .contact-ul{
        display: flex;
        align-items: center;
        .number{
          color: #4077ff;
          font-size: 22px;
          font-weight: bold;
        }
      }
      .connection{
        margin-top: 30px;
        .text{
          line-height: 2;
        }
      }
    }
    .flex-sb{
      display: flex;
      justify-content: space-between;
      align-items: stretch;
    }
  }
  .ivu-modal{
    width: 5rem;
    .m-imgBodel{
      height: 4.6rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .img{
        min-width: 50%;
      }
    }
  }
  /deep/ .ivu-modal-content{
    background-color: inherit;
    box-shadow: inherit;
  }
  /deep/ .ivu-modal-close .ivu-icon-ios-close{
    color:#fff;
    font-size: 0.5rem;
  }
</style>
